import React, { useState } from "react";
import EditCourseDetail from "./EditCourseDetail";
import EditTopicDetail from "./EditTopicDetail";
const intialState = {
  editTopicModal: false,
};
const EditLecture = () => {
  const [iState, setUpdateState] = useState(intialState);
  const { editTopicModal } = iState;
  return (
    <>
      <div className="WrapperArea">
        <div className="WrapperBox">
          <div className="Small-Wrapper">
            <div className="TitleBox Border">
              <h4 className="Title">Edit Lecture</h4>
            </div>
            <div className="CommonForm">
              <div className="form-group">
                <label>Lecture Name</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter lecture name"
                />
              </div>
            </div>
            <div className="TitleBox Border">
              <h4 className="Title">Course &amp; Video</h4>
            </div>
            <div className="CommonForm">
              <div className="UploadBox Image">
                <span>
                  <img src="images/upload.png" />
                </span>
                <p>
                  <label>Upload Lecture Video </label> <br /> or drag &amp; drop
                </p>
              </div>
              <div className="UploadBox">
                <span>
                  <img src="images/upload-video.png" />
                </span>
                <p>
                  <label>Click to Upload </label> or <br /> drag &amp; drop
                </p>
              </div>
            </div>
            <button className="Button">Add Lecture</button>
            <div className="TableList mt-4">
              <table className="table-hover">
                <thead>
                  <tr>
                    <th>Sr. No</th>
                    <th>Lecture Id</th>
                    <th>Video</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>001</td>
                    <td>L-140</td>
                    <td>Link (language 1)</td>
                    <td>
                      <div className="Actions">
                        <a
                          className="Edit"
                          onClick={() => {
                            setUpdateState((prev) => ({
                              ...prev,
                              editTopicModal: true,
                            }));
                          }}
                        >
                          <i className="fa-regular fa-pen-to-square" />
                        </a>
                        <a
                          className="Delete"
                          href="javascript:void(0);"
                          data-toggle="modal"
                          data-target="#LectureDelete"
                        >
                          <i className="fa-regular fa-trash-can" />
                        </a>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>001</td>
                    <td>L-140</td>
                    <td>Link (language 1)</td>
                    <td>
                      <div className="Actions">
                        <a
                          className="Edit"
                          href="javascript:void(0);"
                          data-toggle="modal"
                          data-target="#EditTopicDetails"
                        >
                          <i className="fa-regular fa-pen-to-square" />
                        </a>
                        <a
                          className="Delete"
                          href="javascript:void(0);"
                          data-toggle="modal"
                          data-target="#LectureDelete"
                        >
                          <i className="fa-regular fa-trash-can" />
                        </a>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>001</td>
                    <td>L-140</td>
                    <td>Link (language 1)</td>
                    <td>
                      <div className="Actions">
                        <a
                          className="Edit"
                          href="javascript:void(0);"
                          data-toggle="modal"
                          data-target="#EditTopicDetails"
                        >
                          <i className="fa-regular fa-pen-to-square" />
                        </a>
                        <a
                          className="Delete"
                          href="javascript:void(0);"
                          data-toggle="modal"
                          data-target="#LectureDelete"
                        >
                          <i className="fa-regular fa-trash-can" />
                        </a>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>001</td>
                    <td>L-140</td>
                    <td>Link (language 1)</td>
                    <td>
                      <div className="Actions">
                        <a
                          className="Edit"
                          href="javascript:void(0);"
                          data-toggle="modal"
                          data-target="#EditTopicDetails"
                        >
                          <i className="fa-regular fa-pen-to-square" />
                        </a>
                        <a
                          className="Delete"
                          href="javascript:void(0);"
                          data-toggle="modal"
                          data-target="#LectureDelete"
                        >
                          <i className="fa-regular fa-trash-can" />
                        </a>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>001</td>
                    <td>L-140</td>
                    <td>Link (language 1)</td>
                    <td>
                      <div className="Actions">
                        <a
                          className="Edit"
                          href="javascript:void(0);"
                          data-toggle="modal"
                          data-target="#EditTopicDetails"
                        >
                          <i className="fa-regular fa-pen-to-square" />
                        </a>
                        <a
                          className="Delete"
                          href="javascript:void(0);"
                          data-toggle="modal"
                          data-target="#LectureDelete"
                        >
                          <i className="fa-regular fa-trash-can" />
                        </a>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>001</td>
                    <td>L-140</td>
                    <td>Link (language 1)</td>
                    <td>
                      <div className="Actions">
                        <a
                          className="Edit"
                          href="javascript:void(0);"
                          data-toggle="modal"
                          data-target="#EditTopicDetails"
                        >
                          <i className="fa-regular fa-pen-to-square" />
                        </a>
                        <a
                          className="Delete"
                          href="javascript:void(0);"
                          data-toggle="modal"
                          data-target="#LectureDelete"
                        >
                          <i className="fa-regular fa-trash-can" />
                        </a>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>001</td>
                    <td>L-140</td>
                    <td>Link (language 1)</td>
                    <td>
                      <div className="Actions">
                        <a
                          className="Edit"
                          href="javascript:void(0);"
                          data-toggle="modal"
                          data-target="#EditTopicDetails"
                        >
                          <i className="fa-regular fa-pen-to-square" />
                        </a>
                        <a
                          className="Delete"
                          href="javascript:void(0);"
                          data-toggle="modal"
                          data-target="#LectureDelete"
                        >
                          <i className="fa-regular fa-trash-can" />
                        </a>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>001</td>
                    <td>L-140</td>
                    <td>Link (language 1)</td>
                    <td>
                      <div className="Actions">
                        <a
                          className="Edit"
                          href="javascript:void(0);"
                          data-toggle="modal"
                          data-target="#EditTopicDetails"
                        >
                          <i className="fa-regular fa-pen-to-square" />
                        </a>
                        <a
                          className="Delete"
                          href="javascript:void(0);"
                          data-toggle="modal"
                          data-target="#LectureDelete"
                        >
                          <i className="fa-regular fa-trash-can" />
                        </a>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="Pagination mb-5">
              <p>Showing 1 to 10 of 97 results</p>
              <ul>
                <li>
                  <a href="javascript:void(0);">
                    <i className="fa fa-angle-left" />
                  </a>
                </li>
                <li>
                  <a href="javascript:void(0);">1</a>
                </li>
                <li className="active">
                  <a href="javascript:void(0);">2</a>
                </li>
                <li>
                  <a href="javascript:void(0);">3</a>
                </li>
                <li>
                  <a href="javascript:void(0);">4</a>
                </li>
                <li>
                  <a href="javascript:void(0);">...</a>
                </li>
                <li>
                  <a href="javascript:void(0);">20</a>
                </li>
                <li>
                  <a href="javascript:void(0);">21</a>
                </li>
                <li>
                  <a href="javascript:void(0);">
                    <i className="fa fa-angle-right" />
                  </a>
                </li>
              </ul>
            </div>
            <a href="add-lecture.html" className="Button Discard">
              Discard
            </a>
            <a href="add-lecture.html" className="Button">
              Publish
            </a>
          </div>
        </div>
      </div>
      {editTopicModal && <EditTopicDetail setUpdateState={setUpdateState} />}
    </>
  );
};

export default EditLecture;
